
import OrderPage from "../containers/OrderPage";


let indexRoutes = [{
    path: "/orders", component:OrderPage, exact: false
}];

export default indexRoutes;
